import React, { useEffect } from "react";

import { useAddSourceFile } from "@/api/knowledge-source/add-source-file";
import FileDrop from "@/components/ui/file-drop";
import { Progress } from "@/components/ui/progress";

import KnowledgeSourceButtons from "../knowledge-source-buttons/knowledge-source-buttons";

const PDFSource = () => {
    const [file, setFile] = React.useState<File | null>(null);

    const { mutate: addPDF, isPending, progress, isSuccess } = useAddSourceFile();

    useEffect(() => {
        if (isSuccess && !isPending) {
            setFile(null);
        }
    }, [isSuccess, isPending]);

    // useEffect(() => {
    //   setIsLoading(isPending);
    // }, [isPending, setIsLoading]);

    const handleAddSource = () => {
        const formData = new FormData();
        if (file) {
            formData.append("file", file);
        }
        addPDF({ file: file });
    };
    return (
        <div>
            <FileDrop fileType="PDF" fileSetter={setFile} file={file} />
            {file && <Progress className="mt-4" value={progress} />}
            <div className="mt-4 border-t p-4">
                <KnowledgeSourceButtons onSubmit={handleAddSource} loading={isPending} />
            </div>
        </div>
    );
};

export default PDFSource;
